
interface Window {
    // should be set in the main layout when the file is used in the apps
    PortalUrl: string | undefined;
}

// This is the main top header used in the Portal and all the apps.
// When used in the apps the file should be loaded after loading top menu HTML.
$(function () {
    $.ajaxSetup({
        // Disable caching of AJAX responses
        cache: false
    });

    // AJAX request fadeout
    $(document)
        .ajaxStart(function () {
            beginAjaxLoading();
        })
        .ajaxStop(function () {
            endAjaxLoading();
        })
        .ajaxError(function () {
            // report about AJAX errors
            bsAlert('AJAX request error!');
        });

    $('#AboutPopupLink2').click(function (e) {
        e.preventDefault();
        let url = <string>$(this).attr('href');
        if (window.PortalUrl) {
            url += (url.indexOf('?') > 0 ? '&' : '?') + 'portalUrl=' + window.PortalUrl;
        }
        ajaxGetHtml(url, function (html) {
            BootstrapDialog.show({
                size: BootstrapDialog.SIZE_WIDE,
                title: _ls('About'),
                message: html,
                nl2br: false,
                buttons: [{
                    label: _ls('OK'),
                    cssClass: 'btn-primary btn-lg',
                    action: function (dialog: BootstrapDialog) {
                        dialog.close();
                    }
                }]
            });
        });
    });


    // TODO: move side panel functions into a separate TS class
    $(document).click(function (e) {
        const $target = $(e.target);
        const $toggle = $target.closest('[data-toggle="nav-panel"]');
        const $targetPanel = $target.closest('.nav-panel');

        if ($toggle.length > 0) {
            // closing any other panel
            $('.nav-panel').removeClass('show');

            // opening the target panel
            const target = $toggle.data('target');
            const $target = $(target);
            $target.addClass('show').trigger($target.prop('id') + ':shown');

        }
        else if ($targetPanel.length == 0 || ($targetPanel.length > 0 && $target.closest('button').data('dismiss') == 'modal')) {
            // closing when clicking outside the panel or the close icon
            $('.nav-panel').removeClass('show').each(function () {
                $(this).trigger(this.id + ':hidden');
            });
        }
    });


    $('#PrivacyPopupLink').click(function (e) {
        e.preventDefault();
        ajaxGetHtml(<string>$(this).attr('href'), function (html) {
            BootstrapDialog.show({
                size: BootstrapDialog.SIZE_WIDE,
                title: _ls('Privacy'),
                message: '<div style="min-height: 50px; height: calc(100vh - 230px); overflow-y: scroll">' + html + '</div>',
                nl2br: false,
                buttons: [{
                    label: 'OK',
                    cssClass: 'btn-primary btn-lg',
                    action: function (dialog: BootstrapDialog) {
                        dialog.close();
                    }
                }]
            });
        });
    });

    // Modules menu
    (function () {
        $('.module-contextual-menu-icon').on('click', function () {
            const $clicked = $(this);
            $('.module-contextual-menu').removeClass('show');
            $clicked.closest('.module-contextual-menu-container').find('.module-contextual-menu').addClass('show');
        });

        $(document).on('click', function (e) {
            if (!$(e.target).hasClass('module-contextual-menu-icon')) {
                $('.module-contextual-menu').removeClass('show');
            }
        });
    }());
});
